import type { ItemDto } from 'cart/services/graphql.types'
import { ProductLocations } from 'product/types/ProductLocations'
import { useResponsive } from 'responsive/hooks/useResponsive/useResponsive'
import { PageType } from 'types/analytics'
import { useAnalytics } from './useAnalytics'
import { useNotifications } from './useNotifications'

interface NotificationHandlerProps {
	location: string
	notShowNotification?: boolean
	cartItems: ItemDto[]
	item: ItemDto
}

export const useNotificationHandler = () => {
	const { isSmall } = useResponsive()
	const { closeFeedbackEvent } = useAnalytics()

	const { addItemTextNotification, addLargeNotification } = useNotifications()

	const handleNotification = (props: NotificationHandlerProps): void => {
		const { location, item, cartItems } = props

		const isShopTheLook =
			location === ProductLocations.ShopTheLook ||
			location === ProductLocations.ShopTheLookSimilars ||
			location === ProductLocations.ShopTheLookBestSellers ||
			location === ProductLocations.Edits

		const isMangoStylist = location === ProductLocations.MangoStylist
		const isInCart = location.includes(PageType.ShoppingCart)

		if (isInCart || isMangoStylist || isShopTheLook) {
			addItemTextNotification()
			return
		}

		addLargeNotification({
			childrenProps: { item, cartItems, isSmall, closeFeedbackEvent },
		})
	}

	return { handleNotification }
}
